import type { Coordinates } from "./types";

export interface CampusConfig {
  id: string;
  name: { en: string; th: string; zh: string };
  center: Coordinates;
  innerBounds: [Coordinates, Coordinates];
  outerBounds: [Coordinates, Coordinates];
  surroundingRoads: string[];
  defaultView: {
    longitude: number;
    latitude: number;
    zoom: number;
    pitch: number;
    bearing: number;
  };
}

export const KMITL: CampusConfig = {
  id: "kmitl-main",
  name: {
    en: "King Mongkut's Institute of Technology Ladkrabang",
    th: "สถาบันเทคโนโลยีพระจอมเกล้าเจ้าคุณทหารลาดกระบัง",
    // NOTE(trilingual): verify official Chinese rendering in the i18n pass.
    zh: "拉卡邦先王理工学院",
  },
  // KMITL main campus, Chalong Krung Rd, Lat Krabang, Bangkok 10520.
  center: [100.779, 13.729],
  // Inner = campus footprint; outer = ~2 km incl. ARL Lat Krabang station,
  // SRT Eastern line, Motorway No. 7, and the surrounding dormitory belt.
  innerBounds: [
    [100.772, 13.721],
    [100.788, 13.736],
  ],
  outerBounds: [
    [100.752, 13.703],
    [100.802, 13.748],
  ],
  surroundingRoads: [
    "Chalong Krung Rd",
    "Lat Krabang Rd",
    "Motorway No. 7",
    "On Nut–Lat Krabang Rd",
    "Romklao Rd",
  ],
  defaultView: {
    longitude: 100.779,
    latitude: 13.729,
    zoom: 14.6,
    pitch: 0,
    bearing: 0,
  },
};
